import { defineComponent as _defineComponent } from 'vue'
import YagiofferSelfPrAppendBox from '@/components/yagioffer/YagiofferSelfPrAppendBox.vue'
import { computed, ref } from 'vue'
import NewRirekishoExampleSentenceDialog from '@/components/format-edit/new-rirekisho/NewRirekishoExampleSentenceDialog.vue'
import RirekishoPrimeUpsellDialog from '@/components/format-edit/rirekisho/RirekishoPrimeUpsellDialog.vue'
import {
  useRirekishoFormatData,
  type RirekishoExampleSentence,
  type RirekishoExampleSentences
} from '@/composables/format-edit/useRirekishoFormatData'


export default /*#__PURE__*/_defineComponent({
  __name: 'RirekishoReasonNewCard',
  props: {
    currentCardId: null,
    exampleSentences: null,
    textareaMinRows: null,
    previewErrors: null,
    exampleKey: { default: 'reason' },
    showPrimeUpsell: { type: Boolean, default: true }
  },
  setup(__props: any) {

const props = __props as { currentCardId?: string, exampleSentences?: RirekishoExampleSentences, textareaMinRows: number, previewErrors: Record<string, string>, exampleKey: 'reason' | 'promotion', showPrimeUpsell: boolean };

const reasonLabel =
  '書類審査、合格のカギは志望動機と自己PRの表現力！最新のAIを使って表現力アップ！'



const formatData = useRirekishoFormatData()
const exampleVisible = ref(false)
const primeVisible = ref(false)

const reasonExamples = computed(() => {
  if (props.exampleKey === 'promotion') {
    return props.exampleSentences?.promotion || []
  }
  return props.exampleSentences?.reason || []
})

function onSelectExample(item: RirekishoExampleSentence) {
  formatData.reasonNew += item.description.replace(/<br>/gi, '\n') + '\n'
}

return { __sfc: true,reasonLabel, props, formatData, exampleVisible, primeVisible, reasonExamples, onSelectExample, YagiofferSelfPrAppendBox, NewRirekishoExampleSentenceDialog, RirekishoPrimeUpsellDialog }
}

})